import { render } from "./AllCoursesPage.vue?vue&type=template&id=7dce7af1&scoped=true"
import script from "./AllCoursesPage.vue?vue&type=script&lang=js"
export * from "./AllCoursesPage.vue?vue&type=script&lang=js"

import "./AllCoursesPage.vue?vue&type=style&index=0&id=7dce7af1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dce7af1"]])

export default __exports__